import _ from 'underscore';
import { mapState } from 'vuex';
import f from '@/application/shared/functions';

export default {
	name: 'common_edit',
	props: {

		edit : Object,
		index : String,

		payload : {
			type : Object,
			default : () => {return {}}
		},

		request : String,
		schema : Object,
		ignoreerrors : Boolean
	},

	data : function(){

		return {
			loading : false,
			values : {}
		}

	},

	created(){
		this.init()
	},

	watch: {
	   
	},
	computed: mapState({
		auth : state => state.auth,
		haschanges : function(){
			return true
		},

		
	}),

	methods : {
		save : function(){
			var r = this.$refs['fields'].get()
			var action = null

			var request = this.request ? f.deep(this.core.api, this.request) : null

			if (r){

				if(!request){
					this.$emit("save", r || {})
	
					return
				}

				var data = {
					... r || {},
					... this.payload || {}
				}

				if(this.edit){

					action = request({
						[index] : this.edit[index],
						... data
					}, {
						preloader : true,
						showStatus : true
					})
				}
				else{
	
					action = request({
						... data
					}, {
						preloader : true,
						showStatus : true
					})
				   
				}
	
				action.then(r => {
	
					this.$emit('success', data)
	
					this.$emit('close')
	
				}).catch((e = {}) => {

					this.$store.commit('icon', {
						icon: 'error',
						message: e
					})

					console.error(e)
				})

			}
		},
		cancel : function(){
			this.$emit('close')
		},

		init : function(){
			
			_.each(this.schema.fields, (f) => {
				this.$set(this.values, f.id, this.edit ? this.edit[f.id] : '')
			})

		}
	},
}